import React from 'react'
import { Heading, List } from 'lib/ui'
import Link from 'lib/components/Link'

import { WHY_PAGES } from 'lib/seo/whyPages'

const Why = ({}) => {
  return (
    <>
      <Heading inverted as="h4" content="Why subscribe?" />
      <List link inverted>
        {WHY_PAGES.filter(p => p.footer !== false).map(p => (
          <Link key={p.href} href={p.href} passHref>
            <List.Item as="a">{p.footerLabel}</List.Item>
          </Link>
        ))}
      </List>
    </>
  )
}

export default Why
